import React from 'react';

export const CifraClubPhoto: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
  const { className, ...rest } = props;
  return (
    <div
      // The className from props will set the size (e.g., h-8 w-8) and it is made circular here
      className={`${className} rounded-full overflow-hidden`}
      {...rest}
    >
      <img
        src="https://nikolasyuri.com.br/wp/wp-content/uploads/2025/07/Cifraclub.jpeg"
        alt="Foto de Nikolas Yuri no Cifra Club"
        // This ensures the image fits within the container
        className="w-full h-full object-cover"
      />
    </div>
  );
};
